<script setup lang="ts">
const props = defineProps<{
    title: string,
    desc: string,
    benefits: {
        title: string,
        desc: string,
        icon: string,
        img: string,
    }[],
}>();

type TBenefit = (typeof props.benefits)[number];
const activeItem = ref<TBenefit>();

function handleOnOpenAccordion(item: TBenefit) {
    activeItem.value = item;
}
</script>

<template>
    <SectionsBase class="gridClass flex flex-col lg:flex-row">
        <div class="w-full lg:w-[60%] lg:pl-10">
            <h2 class="lg:text-start!">{{ props.title }}</h2>
            <p class="lg:text-start! mt-3">{{ props.desc }}</p>
            <Transition name="fade" mode="out-in">
                <img
                    :src="activeItem?.img"
                    :key="activeItem?.img"
                    width="600"
                    class="w-full lg:hidden my-3"
                    :alt="activeItem?.title ?? 'مزایای محصول'"
                />
            </Transition>
            <div class="w-full h-full flex flex-col divide-y divide-gray-300">
                <AccordionGroup>
                    <Accordion 
                        v-for="item in benefits" 
                        :key="item.title"
                        class="p-4"
                        @open="() => handleOnOpenAccordion(item)"
                    >
                        <template #head="{ isOpen, openAccordion }">
                            <div 
                                class="flex items-center justify-between gap-1 mb-3 cursor-pointer select-none"
                                @click="openAccordion"
                            >
                                <div class="flex items-center gap-2">
                                    <Icon 
                                        :name="item.icon"
                                        class="text-[#0166FF] transition-colors duration-300"
                                        :class="isOpen && 'text-secondary-600'"
                                        size="20"
                                    />
                                    <h3 class="text-gray-500 font-bold">{{ item.title }}</h3>
                                </div>
                                <Icon 
                                    name="solar:alt-arrow-down-outline" 
                                    class="text-[#0166FF] transition-transform duration-300"
                                    :class="isOpen && '-rotate-180 text-secondary-600'"
                                    size="20"
                                />
                            </div>
                        </template>
                        <template #body>
                            <p class="px-11 text-gray-500 text-sm">
                                {{ item.desc }}
                            </p>
                        </template>
                    </Accordion>
                </AccordionGroup>
            </div>
        </div>
        <div class="w-full lg:w-[40%] hidden lg:block">
            <Transition name="fade" mode="out-in">
                <img
                    :src="activeItem?.img"
                    :key="activeItem?.img"
                    width="600"
                    class="w-full"
                    :alt="activeItem?.title ?? 'مزایای محصول'"
                />
            </Transition>
        </div>
    </SectionsBase>
</template>